import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_mst_sales_favourite_item_link_RowClass } from '../../../dbschema';

export class SalesFavouriteItemLinkContainer extends BaseContainerModel {
  bl_fi_mst_sales_favourite_item_link: bl_fi_mst_sales_favourite_item_link_RowClass = new bl_fi_mst_sales_favourite_item_link_RowClass();
}
